import styled from 'styled-components'

interface IProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
  label?: string
  options: { value: string | number; label: string }[]
}

export const Select = ({ name, label, options, ...extraProps }: IProps) => {
  return (
    <Div>
      <label htmlFor={name}>
        {label && <div className="labelText">{label}</div>}
        <select name={name} id={name} {...extraProps}>
          {options.map((option, i) => (
            <option key={i} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </Div>
  )
}

const Div = styled.div`
  width: 100%;

  label {
    width: 100%;

    & > * {
      color: ${({ theme }) => theme.colors.grey.dark};
    }

    select {
      ${({ theme }) => theme.typography.s.normal};
      color: ${({ theme }) => theme.colors.grey.dark};
      padding: 0.75rem 0.75rem;
      border: none;
      outline: 1px solid ${({ theme }) => theme.colors.grey.dark};
      border-radius: ${({ theme }) => theme.borderRadius.normal};
      width: 100%;

      &:focus {
        outline-color: ${({ theme }) => theme.colors.primary.light};
      }

      &::placeholder {
        color: ${({ theme }) => theme.colors.grey.dark}80;
      }
    }
  }

  .labelText {
    text-align: left;
    ${({ theme }) => theme.typography.xxs.normal};
    padding-bottom: 0.25rem;
  }
`
